import exicom from '../pages/Sponsors/Sponsors/exicom logo.png';
import meraHoardings from '../pages/Sponsors/Sponsors/Merahording.png';
import redFm from '../pages/Sponsors/Sponsors/redFM.webp';
import rysum from '../pages/Sponsors/Sponsors/Rysum logo.png';
import sharesquare from '../pages/Sponsors/Sponsors/Sharesquare logo.png';
import telanganaTourism from '../pages/Sponsors/Sponsors/Telangana_Tourism.webp';

// Grouped by partnership tier, in display order.
export const SPONSOR_TIERS = [
  {
    tier: 'Principal Sponsor',
    sponsors: [{ name: 'Telangana Tourism', logo: telanganaTourism, href: 'https://tourism.telangana.gov.in/' }],
  },
  {
    tier: 'Investment Sponsor',
    sponsors: [{ name: 'ShareSquare', logo: sharesquare, href: 'https://sharesquare.ae/' }],
  },
  { tier: 'Entertainment Partner', sponsors: [{ name: 'Red FM', logo: redFm, href: 'https://www.redfmindia.in/' }] },
  { tier: 'Kit Partner', sponsors: [{ name: 'Rysum Sports', logo: rysum, href: 'https://rysumsports.com/' }] },
  {
    tier: 'Outdoor Media Partner',
    sponsors: [{ name: 'Mera Hoardings', logo: meraHoardings, href: 'http://www.merahoardings.com/' }],
  },
  {
    tier: 'Associate Sponsor',
    sponsors: [{ name: 'Exicom Tele-Systems', logo: exicom, href: 'https://www.exicom.com/' }],
  },
];

export const ALL_SPONSORS = SPONSOR_TIERS.flatMap(({ sponsors }) => sponsors);
